import styled from 'styled-components';

export const SectionContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export default SectionContent;